import { DateUtils } from '../../../common/utils/DateUtils';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { Operation } from '../models/Operation';

export class OperationMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Operation {
    const id = this.gqlIdEncoder.decode(data.id);
    const timestamp = data.timestamp ? DateUtils.toMoment(data.timestamp) : null;

    return new Operation(id, data.type, data.context, data.algorithms, timestamp);
  }
}
